/* Kompresyon Pro — tema scriptleri */
(function () {
  'use strict';
  const T = window.theme || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* ---------- Para formatı ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || T.moneyFormat || '{{amount}} TL';
    const fmt = (n, dec, thou, decSep) => {
      dec = dec == null ? 2 : dec;
      if (isNaN(n) || n == null) return '0';
      n = (n / 100.0).toFixed(dec);
      const parts = n.split('.');
      const whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + (thou == null ? ',' : thou));
      return parts[1] ? whole + (decSep == null ? '.' : decSep) + parts[1] : whole;
    };
    const match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return format;
    let v;
    switch (match[1]) {
      case 'amount': v = fmt(cents, 2); break;
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      case 'amount_with_period_and_space_separator': v = fmt(cents, 2, ' ', '.'); break;
      case 'amount_with_space_separator': v = fmt(cents, 2, ' ', ','); break;
      default: v = fmt(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, v);
  }
  window.formatMoney = formatMoney;

  /* ---------- Drawer & modal ---------- */
  function openDrawer(el) {
    if (!el) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
  }
  function closeDrawer(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) document.body.classList.remove('no-scroll');
  }
  document.addEventListener('click', (e) => {
    const close = e.target.closest('[data-drawer-close]');
    if (close) { closeDrawer(close.closest('.drawer')); return; }
    if (e.target.closest('[data-menu-open]')) { openDrawer($('#MenuDrawer')); return; }
    const cartOpen = e.target.closest('[data-cart-open]');
    if (cartOpen && T.cartType === 'drawer') { e.preventDefault(); refreshCart().then(() => openDrawer($('#CartDrawer'))); return; }
    const modalOpen = e.target.closest('[data-modal-open]');
    if (modalOpen) {
      e.preventDefault();
      const m = document.getElementById(modalOpen.dataset.modalOpen);
      if (m && m.showModal) m.showModal();
      return;
    }
    if (e.target.closest('[data-modal-close]')) { e.target.closest('dialog').close(); return; }
    if (e.target.tagName === 'DIALOG') e.target.close();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') $$('.drawer.is-open').forEach(closeDrawer);
  });

  /* ---------- Sepet ---------- */
  const escapeHtml = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  function renderCart(cart) {
    $$('[data-cart-bubble]').forEach((b) => { b.textContent = cart.item_count; b.classList.toggle('is-empty', cart.item_count === 0); });
    $$('[data-cart-count]').forEach((b) => (b.textContent = '(' + cart.item_count + ')'));
    $$('[data-cart-subtotal]').forEach((b) => (b.textContent = formatMoney(cart.total_price)));

    const ship = $('[data-free-shipping]');
    if (ship) {
      const th = Number(T.freeShippingThreshold || 0);
      if (th > 0 && cart.item_count > 0) {
        const left = th - cart.total_price;
        const pct = Math.min(100, (cart.total_price / th) * 100);
        ship.innerHTML = (left > 0 ? T.strings.freeShippingRemaining.replace('[amount]', '<strong>' + formatMoney(left) + '</strong>') : T.strings.freeShippingReached) +
          '<div class="shipping-bar"><span style="width:' + pct + '%"></span></div>';
      } else ship.innerHTML = '';
    }

    const wrap = $('[data-cart-items]');
    if (!wrap) return;
    if (!cart.items.length) { wrap.innerHTML = '<p class="drawer__empty">' + T.strings.cartEmpty + '</p>'; return; }
    wrap.innerHTML = cart.items.map((item, i) => {
      const img = item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
      const variant = item.product_has_only_default_variant ? '' : '<p class="cart-item__variant">' + escapeHtml(item.variant_title) + '</p>';
      const disc = (item.line_level_discount_allocations || []).map((d) => '<p class="cart-item__discount">' + escapeHtml(d.discount_application.title) + ' (-' + formatMoney(d.amount) + ')</p>').join('');
      const compare = item.original_line_price > item.final_line_price ? '<s>' + formatMoney(item.original_line_price) + '</s>' : '';
      return '<div class="cart-item" data-line="' + (i + 1) + '">' +
        '<a href="' + item.url + '" class="cart-item__img">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div><p class="cart-item__title">' + escapeHtml(item.product_title) + '</p>' + variant + disc +
        '<div class="quantity"><button type="button" data-line-qty="' + (item.quantity - 1) + '" aria-label="-">−</button>' +
        '<input type="number" value="' + item.quantity + '" min="0" data-line-input aria-label="Adet">' +
        '<button type="button" data-line-qty="' + (item.quantity + 1) + '" aria-label="+">+</button></div>' +
        '<br><button type="button" class="cart-item__remove" data-line-qty="0">' + T.strings.remove + '</button></div>' +
        '<div class="cart-item__price">' + compare + formatMoney(item.final_line_price) + '</div></div>';
    }).join('');
  }

  function refreshCart() {
    return fetch(T.routes.cartJs, { headers: { Accept: 'application/json' } }).then((r) => r.json()).then((c) => { renderCart(c); return c; });
  }

  function changeLine(line, quantity) {
    return fetch(T.routes.cartChange, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity })
    }).then((r) => r.json()).then(renderCart);
  }

  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-line-qty]');
    if (!b) return;
    const line = Number(b.closest('[data-line]').dataset.line);
    changeLine(line, Math.max(0, Number(b.dataset.lineQty)));
  });
  document.addEventListener('change', (e) => {
    if (!e.target.matches('[data-line-input]')) return;
    const line = Number(e.target.closest('[data-line]').dataset.line);
    changeLine(line, Math.max(0, Number(e.target.value)));
  });

  function addItems(items) {
    return fetch(T.routes.cartAdd, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items })
    }).then((r) => r.json().then((data) => {
      if (!r.ok || data.status) throw new Error(data.description || data.message || T.strings.error);
      return data;
    }));
  }

  /* ---------- Teslimat tarihi ---------- */
  const MONTHS = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];
  $$('[data-delivery-range]').forEach((el) => {
    const add = (n) => { const d = new Date(); let added = 0; while (added < n) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0) added++; } return d; };
    const a = add(Number(el.dataset.min || 1)), b = add(Number(el.dataset.max || 3));
    el.textContent = a.getDate() + ' ' + MONTHS[a.getMonth()] + ' - ' + b.getDate() + ' ' + MONTHS[b.getMonth()];
  });

  /* ---------- Ürün ---------- */
  function initProduct(root) {
    const jsonEl = $('[data-product-json]', root);
    if (!jsonEl) return;
    const product = JSON.parse(jsonEl.textContent);
    const form = $('.product-form', root);
    const idInput = $('[data-variant-id]', root);
    const qtyInput = $('[data-form-qty]', root);
    const atc = $('[data-add-to-cart]', root);
    const atcText = $('[data-atc-text]', root);
    const atcDefault = atcText ? atcText.textContent : T.strings.addToCart;
    const errorBox = $('[data-form-error]', root);
    const sid = root.dataset.sectionId;
    let variant = product.variants.find((v) => idInput && String(v.id) === idInput.value) || product.variants[0];

    const findVariant = (opts) => product.variants.find((v) => v.options.every((o, i) => o === opts[i]));
    const selectedOptions = () => product.options.map((_, i) => {
      const c = $('input[name="' + sid + '-option-' + i + '"]:checked', root);
      return c ? c.value : variant.options[i];
    });

    /* Galeri */
    const track = $('[data-gallery-track]', root);
    const slides = track ? $$('.gallery__slide', track) : [];
    const thumbs = $$('[data-thumb-index]', root);
    const dots = $$('.gallery__dot', root);
    const goTo = (i) => { if (!track || !slides[i]) return; track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' }); };
    const currentIndex = () => track ? Math.round(track.scrollLeft / (track.clientWidth || 1)) : 0;
    if (track) {
      let t;
      track.addEventListener('scroll', () => {
        clearTimeout(t);
        t = setTimeout(() => {
          const i = currentIndex();
          thumbs.forEach((th, k) => th.classList.toggle('is-active', k === i));
          dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
          if (thumbs[i]) thumbs[i].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
        }, 60);
      }, { passive: true });
    }
    thumbs.forEach((th) => th.addEventListener('click', () => goTo(Number(th.dataset.thumbIndex))));
    const prev = $('[data-gallery-prev]', root), next = $('[data-gallery-next]', root);
    if (prev) prev.addEventListener('click', () => goTo(Math.max(0, currentIndex() - 1)));
    if (next) next.addEventListener('click', () => goTo(currentIndex() + 1 >= slides.length ? 0 : currentIndex() + 1));

    /* Paketler */
    const bundles = $$('[data-bundle]', root);
    const selectedBundle = () => bundles.find((b) => b.classList.contains('is-selected')) || bundles[0];
    function bundleQty() {
      const b = selectedBundle();
      return b ? Number(b.dataset.qty || 1) : Number(($('[data-qty-input]', root) || { value: 1 }).value || 1);
    }
    function updateBundlePrices() {
      bundles.forEach((b) => {
        const q = Number(b.dataset.qty || 1), d = Number(b.dataset.discount || 0);
        const price = Math.round(variant.price * q * (100 - d) / 100);
        const unitCompare = Math.max(variant.compare_at_price || 0, variant.price);
        const compare = unitCompare * q;
        const p = $('[data-bundle-price]', b), c = $('[data-bundle-compare]', b);
        if (p) p.textContent = formatMoney(price);
        if (c) { c.textContent = formatMoney(compare); c.hidden = !(compare > price); }
      });
    }
    bundles.forEach((b) => {
      b.addEventListener('click', (e) => {
        if (e.target.closest('select')) { if (b.classList.contains('is-selected')) return; }
        bundles.forEach((o) => o.classList.toggle('is-selected', o === b));
        const r = $('input[type=radio]', b); if (r) r.checked = true;
        syncQty();
      });
    });

    /* Adet */
    const qtyBox = $('[data-quantity]', root);
    if (qtyBox) {
      const input = $('[data-qty-input]', qtyBox);
      $('[data-qty-minus]', qtyBox).addEventListener('click', () => { input.value = Math.max(1, Number(input.value) - 1); syncQty(); });
      $('[data-qty-plus]', qtyBox).addEventListener('click', () => { input.value = Number(input.value) + 1; syncQty(); });
      input.addEventListener('change', syncQty);
    }
    function syncQty() { if (qtyInput) qtyInput.value = bundleQty(); }

    /* Varyant güncelleme */
    function setButtonState() {
      if (!atc) return;
      const ok = variant && variant.available;
      atc.disabled = !ok;
      if (atcText) atcText.textContent = ok ? atcDefault : (variant ? T.strings.soldOut : T.strings.unavailable);
      const bn = $('[data-buy-now]', root); if (bn) bn.disabled = !ok;
    }
    function updatePrices() {
      $$('[data-price]', root).forEach((el) => (el.textContent = formatMoney(variant.price)));
      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      $$('[data-compare]', root).forEach((el) => { el.hidden = !onSale; if (onSale) el.textContent = formatMoney(variant.compare_at_price); });
      const save = $('[data-save-badge]', root);
      if (save) { save.hidden = !onSale; const a = $('[data-save-amount]', save); if (a && onSale) a.textContent = formatMoney(variant.compare_at_price - variant.price); }
      const gb = $('[data-gallery-badge]', root);
      if (gb) { gb.hidden = !onSale; if (onSale) gb.textContent = '%' + Math.floor((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + ' İndirim'; }
      updateBundlePrices();
    }
    function onOptionChange() {
      const opts = selectedOptions();
      const v = findVariant(opts);
      $$('[data-option-index]', root).forEach((fs) => {
        const i = Number(fs.dataset.optionIndex); const lbl = $('[data-option-value]', fs); if (lbl) lbl.textContent = opts[i];
      });
      if (!v) { variant = null; setButtonState(); return; }
      variant = v;
      if (idInput) idInput.value = v.id;
      updatePrices();
      setButtonState();
      // Paket satırlarını da seçilen varyanta getir
      $$('[data-bundle-item]', root).forEach((row) => {
        $$('[data-item-option]', row).forEach((sel) => { sel.value = v.options[Number(sel.dataset.itemOption)]; });
      });
      if (v.featured_media && track) {
        const idx = slides.findIndex((s) => s.dataset.mediaId === String(v.featured_media.id));
        if (idx > -1) goTo(idx);
      }
      if (root.dataset.updateUrl === 'true' && window.history.replaceState) {
        const url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    $$('[data-variant-picker] input[type=radio]', root).forEach((r) => r.addEventListener('change', onOptionChange));

    /* Sepete ekleme */
    function buildItems() {
      const b = selectedBundle();
      const rows = b ? $$('[data-bundle-item]', b) : [];
      if (rows.length) {
        const map = new Map();
        for (const row of rows) {
          const opts = product.options.map((_, i) => { const s = $('[data-item-option="' + i + '"]', row); return s ? s.value : variant.options[i]; });
          const v = findVariant(opts);
          if (!v || !v.available) throw new Error((opts.join(' / ')) + ' — ' + T.strings.soldOut);
          map.set(v.id, (map.get(v.id) || 0) + 1);
        }
        return Array.from(map, ([id, quantity]) => ({ id, quantity }));
      }
      if (!variant || !variant.available) throw new Error(T.strings.soldOut);
      return [{ id: variant.id, quantity: bundleQty() }];
    }
    function submit(goCheckout) {
      if (errorBox) errorBox.hidden = true;
      let items;
      try { items = buildItems(); } catch (err) { if (errorBox) { errorBox.textContent = err.message; errorBox.hidden = false; } return; }
      if (atc) { atc.disabled = true; if (atcText) atcText.textContent = T.strings.adding; }
      addItems(items).then(() => {
        if (goCheckout || T.cartType === 'checkout') { window.location.href = '/checkout'; return; }
        if (T.cartType === 'page') { window.location.href = T.routes.cart; return; }
        return refreshCart().then(() => openDrawer($('#CartDrawer')));
      }).catch((err) => {
        if (errorBox) { errorBox.textContent = err.message || T.strings.error; errorBox.hidden = false; }
      }).finally(() => { setButtonState(); });
    }
    if (form) form.addEventListener('submit', (e) => { e.preventDefault(); submit(false); });
    const buyNow = $('[data-buy-now]', root);
    if (buyNow) buyNow.addEventListener('click', () => submit(true));

    /* Yapışkan buton */
    const sticky = $('[data-sticky-atc]', root);
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        const below = en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', !en.isIntersecting && below);
      }).observe(atc);
      const sb = $('[data-sticky-buy]', sticky);
      if (sb) sb.addEventListener('click', () => scrollToBuy(root));
    }

    syncQty();
    updateBundlePrices();
  }

  function scrollToBuy(root) {
    root = root || $('[data-product]');
    if (!root) { window.location.href = (T.routes.root || '/') + 'collections/all'; return; }
    const target = $('[data-variant-picker]', root) || $('[data-bundles]', root) || $('.product-form', root) || root;
    const y = target.getBoundingClientRect().top + window.scrollY - 110;
    window.scrollTo({ top: y, behavior: 'smooth' });
    target.animate && target.animate([{ boxShadow: '0 0 0 0 transparent' }, { boxShadow: '0 0 0 6px rgba(79,174,106,.35)' }, { boxShadow: '0 0 0 0 transparent' }], { duration: 1200, delay: 400 });
  }
  document.addEventListener('click', (e) => { if (e.target.closest('[data-scroll-buy]')) { e.preventDefault(); scrollToBuy(); } });

  $$('[data-product]').forEach(initProduct);

  // Tema düzenleyicide bölüm yeniden yüklenince
  document.addEventListener('shopify:section:load', (e) => { $$('[data-product]', e.target).forEach(initProduct); });

  // Sayfa açılışında sepet balonunu güncel tut (önbellekli sayfalar için)
  if ($('[data-cart-items]')) refreshCart().catch(() => {});
})();
